import React, { useEffect, useState } from "react";
import { HashRouter as Router, Route, Routes, Link, NavLink, useLocation } from 'react-router-dom';
import { ROUTELIST } from "./routes";
import { Button } from 'antd';
import logo from "../media/LOGO.png";

import TestimonialPage from "../pages/Testimonial";
import Profile from "../pages/Profile";
import { Footer } from "antd/es/layout/layout";

import {
    FacebookFilled,
    InstagramFilled,
    LinkedinFilled,
    MailOutlined,
    PhoneFilled,
    TikTokFilled,
    WhatsAppOutlined,
    XOutlined,
    CloseOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    ClockCircleOutlined,
    DownOutlined,
    RightOutlined,
} from '@ant-design/icons';
import axios from "axios";
import ProjectsDetails from "../pages/ProjectDetails/Index";


const useCSRF = () => {
    useEffect(() => {
        const fetchCSRFToken = async () => {
            try {
                const response = await axios.get("http://localhost:8000/api/csrf", { withCredentials: true });
                console.log("CSRF Token:", response.data.csrfToken);
                localStorage.setItem("csrfToken", response.data.csrfToken);
            } catch (error) {
                console.error("Error fetching CSRF token:", error);
            }
        };

        fetchCSRFToken();
    }, []);
};

const SidebarMenu = ({
    isExpanded,
    toggleMenu,
}: {
    isExpanded: boolean;
    toggleMenu: () => void;
}) => {
    const location = useLocation();
    const [openDiv, setOpenDiv] = useState<number | null>(null);

    useEffect(() => {
        const activeParentIndex = ROUTELIST.findIndex((menuitem) =>
            menuitem.children?.some((child) => child.path === location.pathname)
        );

        if (activeParentIndex >= 0) {
            setOpenDiv(activeParentIndex);
        }
    }, [location.pathname]);

    const handleDivClick = (index: number, hasChildren: boolean) => {
        if (hasChildren) {
            setOpenDiv(openDiv === index ? null : index);
            return;
        }

        toggleMenu();
    };

    const isParentActive = (menuitem: typeof ROUTELIST[number]) =>
        Boolean(menuitem.children?.some((child) => child.path === location.pathname));

    return (
        <>
            {isExpanded && (
                <button
                    type="button"
                    className="side-menu-overlay"
                    onClick={toggleMenu}
                    aria-label="Close navigation menu"
                />
            )}
            <aside className={`side-menu ${isExpanded ? "open" : ""}`} aria-hidden={!isExpanded}>
                <div className="side-menu-shell">
                    <div className="side-menu-header">
                        <div className="side-menu-brand">
                            <img src={logo} alt="Brahma Jyoti Holdings logo" className="side-menu-logo" />
                            <div>
                                <h2 className="side-menu-title">Brahma Jyoti Holdings</h2>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="side-menu-close"
                            onClick={toggleMenu}
                            aria-label="Close navigation menu"
                        >
                            <CloseOutlined />
                        </button>
                    </div>

                    <div className="side-menu-links">
                        {ROUTELIST.map((menuitem, index) => {
                            const hasChildren = Boolean(menuitem.children?.length);
                            const expanded = openDiv === index;
                            const parentActive = isParentActive(menuitem);

                            return (
                                <div
                                    key={menuitem.id}
                                    className={`side-menu-group ${parentActive ? "active" : ""} ${expanded ? "expanded" : ""}`}
                                >
                                    {hasChildren ? (
                                        <button
                                            type="button"
                                            className="side-menu-trigger"
                                            onClick={() => handleDivClick(index, true)}
                                            aria-expanded={expanded}
                                        >
                                            <span className="side-menu-trigger-label">{menuitem.name}</span>
                                            <span className="side-menu-trigger-icon">
                                                {expanded ? <DownOutlined /> : <RightOutlined />}
                                            </span>
                                        </button>
                                    ) : (
                                        <NavLink
                                            to={menuitem.path || "/"}
                                            className={({ isActive }) =>
                                                `side-menu-link ${isActive ? "active" : ""}`
                                            }
                                            onClick={toggleMenu}
                                        >
                                            {menuitem.name}
                                        </NavLink>
                                    )}

                                    {hasChildren && expanded && (
                                        <div className="side-menu-children">
                                            {menuitem.children?.map((child) => (
                                                <NavLink
                                                    key={child.path}
                                                    to={child.path}
                                                    className={({ isActive }) =>
                                                        `side-menu-child-link ${isActive ? "active" : ""}`
                                                    }
                                                    onClick={toggleMenu}
                                                >
                                                    {child.name}
                                                </NavLink>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>

                    <div className="side-menu-footer">
                        <p className="side-menu-footer-label">Business Hours</p>
                        <p className="side-menu-footer-copy">9:30AM - 5:30PM</p>
                        <p className="side-menu-footer-label">Phone</p>
                        <p className="side-menu-footer-copy">+977 015922895 | +977 9764399066</p>
                    </div>
                </div>
            </aside>
        </>
    );
};

const RouterHandler = () => {
    const [isExpanded, setExpanded] = useState(false);
    const toggleMenu = () => {
        console.log("Toggled");
        setExpanded(!isExpanded);
    };

    //useCSRF();
    return (
        <div className="app">
            <Router>
                <div className="heading">
                    <div className="navbar">
                        <Link to={"/#"} className="navbar-brand">
                            <img src={logo} alt="Brahma Jyoti Holdings logo" className="navbar-logo" />
                            <div className="navbar-brand-copy">
                                <span className="navbar-brand-kicker">Brahma Jyoti Holdings</span>
                            </div>
                        </Link>
                        <div className="navbar-links">
                            {ROUTELIST.map((menuitem, i) => (
                                menuitem.children != null ? (
                                    <div key={i + "hover"} className="hover-box">
                                        <button type="button" key={i + "p"} className='navbar-trigger'>
                                            <span className='link-button'>{menuitem.name}</span>
                                            <span className="navbar-trigger-icon"><DownOutlined /></span>
                                        </button>
                                        <div key={i + "box"} className="expandable-box">
                                            {menuitem.children.map((child, j) => (
                                                <NavLink key={j} to={child.path} className='navbar-dropdown-link'>{child.name}</NavLink>
                                            ))}
                                        </div>
                                    </div>
                                ) : (
                                    <div key={i + "box2"} className="hover-box">
                                        <NavLink key={i} to={menuitem.path} className={({ isActive }) => `navbar-link ${isActive ? "active" : ""}`}>
                                            {menuitem.name}
                                        </NavLink>
                                    </div>
                                )
                            ))}
                        </div>
                        <Button
                            type="text"
                            className={`navbar-menu-toggle ${isExpanded ? "active" : ""}`}
                            icon={isExpanded ? <MenuFoldOutlined className="navbar-menu-icon" /> : <MenuUnfoldOutlined className="navbar-menu-icon" />}
                            onClick={toggleMenu}
                        />
                    </div>

                    <div className="businesshour">
                        <p><ClockCircleOutlined /> Business Hours:
                            <br /> 9:30AM - 5:30PM
                        </p>
                        <p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<PhoneFilled /> Phone:
                            <br /> +977 015922895 |  +977 9764399066 |  +977 9764399067
                        </p>
                    </div>
                </div>

                <SidebarMenu isExpanded={isExpanded} toggleMenu={toggleMenu} />

                <div className="playground">
                    <Routes>
                        {[...ROUTELIST, {
                            id: 7,
                            path: "/project/:name",
                            element: <ProjectsDetails />,
                            name: "Project Details"
                        },].map((page, i) => (
                            page.children == null ? (
                                <Route key={i} path={page.path} element={page.element}></Route>
                            ) : (
                                <>
                                    {page.children.map((child, j) => (
                                        <Route key={j} path={child.path} element={child.element}></Route>
                                    ))}
                                </>
                            )
                        ))}
                        <Route path={"/testimonials"} element={<TestimonialPage />}></Route>
                        <Route path={"/profile"} element={<Profile />}></Route>
                    </Routes>
                </div>
            </Router>
            <Footer className="footer">
                <div className="footer-shell">
                    <div className="footer-brand">
                        <img src={logo} alt="Brahma Jyoti Holdings logo" className="footer-logo" />
                        <div className="footer-brand-copy">
                            <b className="footer-title">Brahma Jyoti Holdings Limited</b>
                            <div className="footer-email-row">
                                <MailOutlined />
                                <a className="footer-link" href="mailto:brahmajyoti01@gmail.com">brahmajyoti01@gmail.com</a>
                                <span className="footer-separator">|</span>
                                <a className="footer-link" href="mailto:contactbrahmajyoti@gmail.com">contactbrahmajyoti@gmail.com</a>
                            </div>
                        </div>
                    </div>
                    <div className="footer-socials">
                        <a className="footer-social-link" href="https://www.facebook.com/people/Brahma-Jyoti-Holdings/61565656058735/?mibextid=ZbWKwL"><FacebookFilled /> Facebook</a>
                        <a className="footer-social-link" href="https://www.instagram.com/brahmagroup04/"><InstagramFilled /> Instagram</a>
                        <a className="footer-social-link" href="https://wa.me/message/HXXBH2BI6B7GD1"><WhatsAppOutlined /> Whatsapp</a>
                        <a className="footer-social-link" href="https://www.linkedin.com/public-profile/settings?trk=d_flagship3_profile_self_view_public_profile"><LinkedinFilled /> Linkedin</a>
                        <a className="footer-social-link" href="https://x.com/brahmagroup01"><XOutlined /> X</a>
                        <a className="footer-social-link" href="https://www.tiktok.com/@brahmagroup03?is_from_webapp=1&sender_device=pc"><TikTokFilled /> Tiktok</a>
                    </div>
                </div>
            </Footer>
        </div>
    );
};

export default RouterHandler;
